import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap'

import { getUsersPendingTrips } from '../selectors'
import { getStatusLabel } from './TripStatus' 

import { getText } from '../lib/text.js'

type UTProps = {
  username: string, 
  userTripsList: Object[], 
}

const UserTripsList = (
  { userTripsList } : UTProps
) => (
  <Panel>
    <Panel.Heading>
      <Panel.Title>
        {getText("Tus negociaciones en progreso")} <small>{getText("(aún no han pagado fianza)")}</small>
      </Panel.Title>
    </Panel.Heading>
    <Panel.Body>
      <ListGroup>
        {
          userTripsList.length == 0 
            ? (<em>0 clientes</em>)
            : userTripsList.map(trip => (
              <ListGroupItem key={trip._id}>
                {getStatusLabel(trip.status)}: <Link to={`/private/trip/${trip._id}`}>{trip.name}{trip.realName ? ` (${trip.realName})` : ""}</Link>
              </ListGroupItem>
            ))
        }
      </ListGroup>
    </Panel.Body>
  </Panel>
)

const stateToProps = (state, props) => ({
  userTripsList: getUsersPendingTrips(state, props),
})

const dispatchToProps = () => ({})

export default connect(stateToProps, dispatchToProps)(UserTripsList)
  
